import { object, string, boolean } from '~utils/validation';

export default object({
  cpf: string()
    .max(14)
    .required('O campo é obrigatório.')
    .cpf('Número de CPF inválido'),
  birthdayDate: string().max(11).required('O campo é obrigatório.'),
  politicallyExposedPerson: boolean().required('O campo é obrigatório.'),
});
